import { createContext, MutableRefObject, useContext } from "react";
import { Subnet } from "../types/subnet";
import { PredefinedParams } from "../../../../../components/slidingpanel/type";
import { NetworkForm } from "../types/formData";
import {
  HandleCheckboxChange,
  HandleInputChange,
  HandleSelectChange,
} from "../../../../../custom-hooks/form/types";

type NetworkFormContextType = {
  error: any;
  formData: NetworkForm;
  handleInputChange: HandleInputChange;
  handleSelectChange: HandleSelectChange;
  handleCheckboxChange: HandleCheckboxChange;
  handleSubnetsChange: (subnets: Subnet[]) => void;
  formWarning: boolean;
  showFormWarning: () => void;
  nameRef: MutableRefObject<HTMLElement | null>;
  regionRef: MutableRefObject<HTMLElement | null>;
  subnetRefs: React.RefObject<HTMLDivElement>[];
  setSubnetRefs: React.Dispatch<
    React.SetStateAction<React.RefObject<HTMLDivElement>[]>
  >;
  predefined_params?: PredefinedParams;
};

export const NetworkFormContext = createContext<NetworkFormContextType | null>(
  null,
);

export const useNetworkFormContext = () => {
  const ctx = useContext(NetworkFormContext);
  if (!ctx) {
    throw new Error(
      "useNetworkFormContext must be used inside NetworkFormProvider",
    );
  }
  return ctx;
};
